// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sidebar: weather metrics highlights, air quality, location map */

.sidebar {
  border-radius: 30px;
}

.sidebar > * {
  padding: 0 0.3rem;
}

.highlights__title,
.air-quality__title,
.static-map__title {
  font-weight: 600;
  font-size: 1.05rem;
}

/* Weather metrics grid */
.highlights__grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 0.5rem;
}

.highlights-card {
  min-height: 120px;
  gap: 0.3rem;
  padding: 0.5rem;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.highlights-card * {
  margin: 0;
}

.highlights-card__icon {
  width: 20px;
  height: 20px;
  vertical-align: middle;
}

.highlights-card__title {
  font-size: 1rem;
  font-weight: 600;
  display: inline;
}

.highlights-data {
  font-size: 1.5rem;
  font-weight: 600;
}

.highlights-card__footnote {
  font-size: 0.9rem;
  font-weight: 400;
}

.air-quality {
  /* Use the exact same properties as your other glass-panels */
  margin-top: 1rem; /* Space from the highlights above */
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
}

.air-quality__icon {
  width: 24px;
}

.air-quality__body {
  text-align: center;
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.air-quality__meter {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: conic-gradient(
    #10b981 0deg 60deg,
    #facc15 60deg 120deg,
    #f97316 120deg 180deg,
    #ef4444 180deg 240deg,
    #8b5cf6 240deg 300deg,
    #4c0519 300deg 360deg
  );
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

/* This creates the "hole" in the donut */
.air-quality__meter-inner {
  width: 100px;
  height: 100px;
  background: #1e293b; /* Match your body background */
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.5);
  /* eslint-disable-next-line css/no-invalid-properties */
  font-family: var(--font-jakarta);
  letter-spacing: -0.02em;
}

.air-quality__meter-value {
  font-size: 1.8rem;
  margin: 0;
  line-height: 1;
}

.air-quality__meter-status {
  font-size: 0.8rem;
  color: #4ade80; /* Match current status color */
  font-weight: 600;
}

.air-quality__stats {
  flex: 1;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.3rem;
  font-feature-settings:
    "tnum" on,
    "lnum" on;
}

.air-quality__pill {
  background: rgba(255, 255, 255, 0.05);
  padding: 0.5rem 0.3rem;
  border-radius: 0.75rem;
  display: flex;
  justify-content: space-between;
  border: 1px solid rgba(255, 255, 255, 0.1);
  font-size: 0.85rem;
}

.air-quality__pill-value {
  font-weight: 500;
}

.air-quality__unit {
  font-size: 0.7rem;
  font-style: italic;
}

.static-map__map {
  min-width: 380px;
  min-height: 300px;
  border-radius: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/styles/components/sidebar.css"],"names":[],"mappings":"AAAA,mEAAmE;;AAEnE;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;EAGE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,gBAAgB,EAAE,oCAAoC;EACtD,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB;;;;;;;GAOC;EACD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,yCAAyC;AACzC;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB,EAAE,+BAA+B;EACpD,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;EAC7C,uDAAuD;EACvD,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc,EAAE,+BAA+B;EAC/C,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX;;aAEW;AACb;;AAEA;EACE,qCAAqC;EACrC,sBAAsB;EACtB,sBAAsB;EACtB,aAAa;EACb,8BAA8B;EAC9B,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB","sourcesContent":["/* Sidebar: weather metrics highlights, air quality, location map */\n\n.sidebar {\n  border-radius: 30px;\n}\n\n.sidebar > * {\n  padding: 0 0.3rem;\n}\n\n.highlights__title,\n.air-quality__title,\n.static-map__title {\n  font-weight: 600;\n  font-size: 1.05rem;\n}\n\n/* Weather metrics grid */\n.highlights__grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 0.5rem;\n}\n\n.highlights-card {\n  min-height: 120px;\n  gap: 0.3rem;\n  padding: 0.5rem;\n  border-radius: 15px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.highlights-card * {\n  margin: 0;\n}\n\n.highlights-card__icon {\n  width: 20px;\n  height: 20px;\n  vertical-align: middle;\n}\n\n.highlights-card__title {\n  font-size: 1rem;\n  font-weight: 600;\n  display: inline;\n}\n\n.highlights-data {\n  font-size: 1.5rem;\n  font-weight: 600;\n}\n\n.highlights-card__footnote {\n  font-size: 0.9rem;\n  font-weight: 400;\n}\n\n.air-quality {\n  /* Use the exact same properties as your other glass-panels */\n  margin-top: 1rem; /* Space from the highlights above */\n  border-radius: 1rem;\n  display: flex;\n  flex-direction: column;\n}\n\n.air-quality__icon {\n  width: 24px;\n}\n\n.air-quality__body {\n  text-align: center;\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n}\n\n.air-quality__meter {\n  width: 120px;\n  height: 120px;\n  border-radius: 50%;\n  background: conic-gradient(\n    #10b981 0deg 60deg,\n    #facc15 60deg 120deg,\n    #f97316 120deg 180deg,\n    #ef4444 180deg 240deg,\n    #8b5cf6 240deg 300deg,\n    #4c0519 300deg 360deg\n  );\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n\n/* This creates the \"hole\" in the donut */\n.air-quality__meter-inner {\n  width: 100px;\n  height: 100px;\n  background: #1e293b; /* Match your body background */\n  border-radius: 50%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.5);\n  /* eslint-disable-next-line css/no-invalid-properties */\n  font-family: var(--font-jakarta);\n  letter-spacing: -0.02em;\n}\n\n.air-quality__meter-value {\n  font-size: 1.8rem;\n  margin: 0;\n  line-height: 1;\n}\n\n.air-quality__meter-status {\n  font-size: 0.8rem;\n  color: #4ade80; /* Match current status color */\n  font-weight: 600;\n}\n\n.air-quality__stats {\n  flex: 1;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.3rem;\n  font-feature-settings:\n    \"tnum\" on,\n    \"lnum\" on;\n}\n\n.air-quality__pill {\n  background: rgba(255, 255, 255, 0.05);\n  padding: 0.5rem 0.3rem;\n  border-radius: 0.75rem;\n  display: flex;\n  justify-content: space-between;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  font-size: 0.85rem;\n}\n\n.air-quality__pill-value {\n  font-weight: 500;\n}\n\n.air-quality__unit {\n  font-size: 0.7rem;\n  font-style: italic;\n}\n\n.static-map__map {\n  min-width: 380px;\n  min-height: 300px;\n  border-radius: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
